import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
const PreguntasFrecuentes = () => {
    const [preguntas, setPreguntas] = useState({
        pregunta_1: false,
        pregunta_2: false,
        pregunta_3: false,
        pregunta_4: false,
        pregunta_5: false,
        pregunta_6: false,
    });
    const navigate = useNavigate();
    return (
        <div className="w-full md:mt-10 mt-5 mb-10">
            <div className="text-[#071829] text-center 2xl:text-4xl xl:text-3xl lg:text-2xl text-xl font-bold  md:text-left  w-5/6 mx-auto  ">
                Preguntas frecuentes
            </div>
            <div className="py-10 md:mt-10 mt-7 mx-auto bg-opacity-50 bg-[#F6F6F9]">
                <div className="flex w-5/6 mx-auto flex-row justify-between items-start md:gap-5 gap-2">
                    <div className="flex flex-col justify-start items-start flex-1">
                        <div className="font-bold xl:text-lg md:text-base text-sm">
                            ¿Blustay administra mi página y mis clientes?
                        </div>
                        <div
                            className={`xl:text-base md:text-sm text-xs mt-5 transition-all duration-500 ease-in-out transform overflow-hidden ${
                                preguntas.pregunta_1
                                    ? "opacity-100 translate-y-0 max-h-screen"
                                    : "opacity-0 translate-y-[-20px] max-h-0"
                            }`}
                        >
                            Blustay le proporciona una plataforma digital para
                            que pueda gestionar de manera independiente su
                            página web y administrar a sus clientes a través del
                            sistema de reservas. Sin embargo, ofrecemos
                            servicios adicionales como Administración Comercial
                            y Operativa (multicanal y plataforma), donde nos
                            encargamos directamente del manejo de su plataforma
                            y clientes. Este servicio tiene un costo mensual y
                            puede ser contratado tanto por clientes suscritos
                            como no suscritos a Blustay.{" "}
                            <span
                                onClick={() =>
                                    navigate("/home/6/servicios-adicionales")
                                }
                                className="font-semibold underline cursor-pointer"
                            >
                                (Ver aquí los servicios adicionales)
                            </span>
                            .
                        </div>
                    </div>

                    <div
                        className={`rounded-full w-7 h-7 p-2 flex justify-center items-center cursor-pointer bg-[#029DE0] text-white transition-transform duration-300 ease-in-out`}
                        onClick={() =>
                            setPreguntas((prev) => ({
                                ...prev,
                                pregunta_1: !prev.pregunta_1,
                            }))
                        }
                    >
                        <span
                            className={`text-2xl leading-none transition-transform duration-300  ease-in-out ${
                                preguntas.pregunta_1
                                    ? "rotate-180 mt-2"
                                    : "rotate-0 mb-1"
                            }`}
                        >
                            {preguntas.pregunta_1 ? "-" : "+"}
                        </span>
                    </div>
                </div>
                <hr className="md:my-8 my-6 w-5/6 mx-auto border-t border-[rgba(24,28,57,0.2)]" />

                <div className="flex w-5/6 mx-auto flex-row justify-between items-start gap-5">
                    <div className="flex flex-col justify-start items-start flex-1">
                        <div className="font-bold xl:text-lg md:text-base text-sm">
                            ¿Cuál es el precio de Blustay?
                        </div>
                        <div
                            className={`xl:text-base md:text-sm text-xs mt-5 transition-all duration-500 ease-in-out transform overflow-hidden ${
                                preguntas.pregunta_2
                                    ? "opacity-100 translate-y-0 max-h-screen"
                                    : "opacity-0 translate-y-[-20px] max-h-0"
                            }`}
                        >
                            El precio varía según la cantidad de unidades que
                            desea administrar. Contamos con tres planes de
                            suscripción diseñados para adaptarse a las
                            necesidades de cada negocio.
                        </div>
                    </div>

                    <div
                        className={`rounded-full w-7 h-7 p-2 flex justify-center items-center cursor-pointer bg-[#029DE0] text-white transition-transform duration-300 ease-in-out`}
                        onClick={() =>
                            setPreguntas((prev) => ({
                                ...prev,
                                pregunta_2: !prev.pregunta_2,
                            }))
                        }
                    >
                        <span
                            className={`text-2xl leading-none transition-transform duration-300  ease-in-out ${
                                preguntas.pregunta_2
                                    ? "rotate-180 mt-2"
                                    : "rotate-0 mb-1"
                            }`}
                        >
                            {preguntas.pregunta_2 ? "-" : "+"}
                        </span>
                    </div>
                </div>
                <hr className="md:my-8 my-6 w-5/6 mx-auto border-t border-[rgba(24,28,57,0.2)]" />

                <div className="flex w-5/6 mx-auto flex-row justify-between items-start gap-5">
                    <div className="flex flex-col justify-start items-start flex-1">
                        <div className="font-bold xl:text-lg md:text-base text-sm">
                            ¿Es necesario firmar un contrato?
                        </div>
                        <div
                            className={`xl:text-base md:text-sm text-xs mt-5 transition-all duration-500 ease-in-out transform overflow-hidden ${
                                preguntas.pregunta_3
                                    ? "opacity-100 translate-y-0 max-h-screen"
                                    : "opacity-0 translate-y-[-20px] max-h-0"
                            }`}
                        >
                            Blustay funciona con una suscripción mensual, sin
                            cobro de comisiones por reservas. Al suscribirse,
                            usted acepta los términos y condiciones del
                            servicio, sin necesidad de firmar un contrato.
                        </div>
                    </div>

                    <div
                        className={`rounded-full w-7 h-7 p-2 flex justify-center items-center cursor-pointer bg-[#029DE0] text-white transition-transform duration-300 ease-in-out`}
                        onClick={() =>
                            setPreguntas((prev) => ({
                                ...prev,
                                pregunta_3: !prev.pregunta_3,
                            }))
                        }
                    >
                        <span
                            className={`text-2xl leading-none transition-transform duration-300  ease-in-out ${
                                preguntas.pregunta_3
                                    ? "rotate-180 mt-2"
                                    : "rotate-0 mb-1"
                            }`}
                        >
                            {preguntas.pregunta_3 ? "-" : "+"}
                        </span>
                    </div>
                </div>
                <hr className="md:my-8 my-6 w-5/6 mx-auto border-t border-[rgba(24,28,57,0.2)]" />

                <div className="flex w-5/6 mx-auto flex-row justify-between items-start gap-5">
                    <div className="flex flex-col justify-start items-start flex-1">
                        <div className="font-bold xl:text-lg md:text-base text-sm">
                             ¿Qué sucede si cancelo mi suscripción?
                        </div>
                        <div
                            className={`xl:text-base md:text-sm text-xs mt-5 transition-all duration-500 ease-in-out transform overflow-hidden ${
                                preguntas.pregunta_4
                                    ? "opacity-100 translate-y-0 max-h-screen"
                                    : "opacity-0 translate-y-[-20px] max-h-0"
                            }`}
                        >
                            Si cancela su suscripción, su página web no
                            desaparecerá, sino que quedará desactivada
                            temporalmente. Si decide reactivar su suscripción
                            más adelante, toda su información se restaurará
                            automáticamente.
                        </div>
                    </div>

                    <div
                        className={`rounded-full w-7 h-7 p-2 flex justify-center items-center cursor-pointer bg-[#029DE0] text-white transition-transform duration-300 ease-in-out`}
                        onClick={() =>
                            setPreguntas((prev) => ({
                                ...prev,
                                pregunta_4: !prev.pregunta_4,
                            }))
                        }
                    >
                        <span
                            className={`text-2xl leading-none transition-transform duration-300  ease-in-out ${
                                preguntas.pregunta_4
                                    ? "rotate-180 mt-2"
                                    : "rotate-0 mb-1"
                            }`}
                        >
                            {preguntas.pregunta_4 ? "-" : "+"}
                        </span>
                    </div>
                </div>
                <hr className="md:my-8 my-6 w-5/6 mx-auto border-t border-[rgba(24,28,57,0.2)]" />

                <div className="flex w-5/6 mx-auto flex-row justify-between items-start gap-5">
                    <div className="flex flex-col justify-start items-start flex-1">
                        <div className="font-bold xl:text-lg md:text-base text-sm">
                             ¿Puedo hacer modificaciones personalizadas a mi
                            página web?
                        </div>
                        <div
                            className={`xl:text-base md:text-sm text-xs mt-5 transition-all duration-500 ease-in-out transform overflow-hidden ${
                                preguntas.pregunta_5
                                    ? "opacity-100 translate-y-0 max-h-screen"
                                    : "opacity-0 translate-y-[-20px] max-h-0"
                            }`}
                        >
                            Sí, es posible realizar cambios personalizados en su
                            página web según sus necesidades. Para ello, se
                            realizará una cotización del servicio con base en
                            los requerimientos específicos.
                        </div>
                    </div>

                    <div
                        className={`rounded-full w-7 h-7 p-2 flex justify-center items-center cursor-pointer bg-[#029DE0] text-white transition-transform duration-300 ease-in-out`}
                        onClick={() =>
                            setPreguntas((prev) => ({
                                ...prev,
                                pregunta_5: !prev.pregunta_5,
                            }))
                        }
                    >
                        <span
                            className={`text-2xl leading-none transition-transform duration-300  ease-in-out ${
                                preguntas.pregunta_5
                                    ? "rotate-180 mt-2"
                                    : "rotate-0 mb-1"
                            }`}
                        >
                            {preguntas.pregunta_5 ? "-" : "+"}
                        </span>
                    </div>
                </div>
                <hr className="md:my-8 my-6 w-5/6 mx-auto border-t border-[rgba(24,28,57,0.2)]" />
                <div className="flex w-5/6 mx-auto flex-row justify-between items-start gap-5">
                    <div className="flex flex-col justify-start items-start flex-1">
                        <div className="font-bold xl:text-lg md:text-base text-sm">
                            ¿Cuáles son los medios de pago para suscribirme?
                        </div>
                        <div
                            className={`xl:text-base md:text-sm text-xs mt-5 transition-all duration-500 ease-in-out transform overflow-hidden ${
                                preguntas.pregunta_6
                                    ? "opacity-100 translate-y-0 max-h-screen"
                                    : "opacity-0 translate-y-[-20px] max-h-0"
                            }`}
                        >
                            <ul className="list-disc pl-5">
                                <li>
                                    Para suscripciones mensuales: Puede pagar
                                    con tarjeta de débito o crédito.
                                </li>
                                <li className="mt-2">
                                    Para suscripciones semestrales y anuales:
                                    Aceptamos pagos mediante transferencia
                                    bancaria y tarjeta de crédito o débito.
                                </li>
                            </ul>
                            <p className="mt-2">
                                Nota: Los pagos con tarjeta de crédito están
                                sujetos a una comisión, según la pasarela de
                                pago utilizada.
                            </p>
                        </div>
                    </div>

                    <div
                        className={`rounded-full w-7 h-7 p-2 flex justify-center items-center cursor-pointer bg-[#029DE0] text-white transition-transform duration-300 ease-in-out`}
                        onClick={() =>
                            setPreguntas((prev) => ({
                                ...prev,
                                pregunta_6: !prev.pregunta_6,
                            }))
                        }
                    >
                        <span
                            className={`text-2xl leading-none transition-transform duration-300  ease-in-out ${
                                preguntas.pregunta_6
                                    ? "rotate-180 mt-2"
                                    : "rotate-0 mb-1"
                            }`}
                        >
                            {preguntas.pregunta_6 ? "-" : "+"}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PreguntasFrecuentes;
